export enum IotActions {
  CREATE = 'create',
  UPDATE = 'update',
  CONFIGURE = 'configure'
}
